import { ApplicationConfig, importProvidersFrom, LOCALE_ID, provideZoneChangeDetection  } from '@angular/core';
import { withInMemoryScrolling } from '@angular/router';
import { provideRouter, withRouterConfig } from '@angular/router';
import { HttpClient, provideHttpClient } from '@angular/common/http';
import { LoginService } from './services/login.service';
import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { StarRatingModule, } from 'angular-star-rating';
import { NgxGalleryModule } from 'ngx-gallery';
//import { FullCalendarModule } from '@fullcalendar/angular';
import { provideAnimations } from "@angular/platform-browser/animations"
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { siteKey } from '../environments/environment.development';
import { RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha-2';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      withInMemoryScrolling({ // Correct configuration for fragment scrolling
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'enabled',
      })
    ),
    provideClientHydration(),
    provideHttpClient(),
    FormsModule,
    importProvidersFrom(StarRatingModule.forRoot()),
    provideAnimations(),
    { provide: LOCALE_ID, useValue: 'sl' },
    provideZoneChangeDetection({ eventCoalescing: true }),
    //{ provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: siteKey }
    ]

};
